import {
  HeroBlock,
  CallToActionBlock,
  FeatureBlock,
  GridBlock,
  CarouselBlock,
  TextContentBlock,
  GalleryBlock,
  VideoPlayerBlock,
  TestimonialBlock,
} from '@/components'
import type { Block, BlockComponent } from '@/types'
import React from 'react'

const blockComponents: {
  [K in Block['blockType']]: BlockComponent<Extract<Block, { blockType: K }>>
} = {
  hero: HeroBlock,
  cta: CallToActionBlock,
  feature: FeatureBlock,
  grid: GridBlock,
  carousel: CarouselBlock,
  testimonial: TestimonialBlock,
  textcontent: TextContentBlock,
  gallery: GalleryBlock,
  videoplayer: VideoPlayerBlock,
}

export function Blocks({ blocks }: Readonly<{ blocks: Block[] }>) {
  if (!blocks?.length) return null

  return (
    <>
      {blocks.map((block, index) => {
        const BlockComponent = blockComponents[block.blockType] as BlockComponent<Block>

        if (!BlockComponent) {
          console.warn(`No component found for block type: ${block.blockType}`)
          return null
        }

        return <BlockComponent key={block.id ?? index} {...block} />
      })}
    </>
  )
}
